import cn from 'classnames';
import React, {FunctionComponent, ReactNode} from 'react';

import './Alert.scss';

interface IAlertProps {
    className?: string,
    type: 'success' | 'info' | 'warn' | 'danger',
}


// Shows a colored box. Used for conveying successes, warnings, and errors.
export const Alert: FunctionComponent<IAlertProps> = function (props) {
    const { children, className, type } = props;

    return (
        <div className={cn('alert', className, type)}>
            {children}
        </div>
    );
};